import { createFeatureSelector, createSelector } from '@ngrx/store';

import { mainHeaderKey, HeaderState } from './header.reducer';

export const selectFavorite = createFeatureSelector<HeaderState>(mainHeaderKey);

export const getInboxCount = createSelector(
  selectFavorite,
  (state: HeaderState) => state && state.inboxCount,
);

export const getFavoriteCount = createSelector(
  selectFavorite,
  (state: HeaderState) => state && state.favoriteCount,
);
